import React from 'react';
import parser, { HTMLReactParserOptions } from 'html-react-parser';
import { useHref, useLinkClickHandler, useLocation } from 'react-router-dom';
import { useClassTopicContent } from 'src/hooks';

// eslint-disable-next-line react/display-name
export const SeekLink = React.forwardRef<HTMLAnchorElement, any>(
  ({ onClick, replace = true, children, state, target, ...rest }, ref) => {
    const location = useLocation();
    const { content } = useClassTopicContent();

    let to = location.pathname;

    if (location.pathname.includes('discussions')) {
      //  check if path name is discussion detail
      to = to.replace('discussions', () => {
        return content.class_topic_id!;
      });
    }

    let href = useHref(to);
    let handleClick = useLinkClickHandler(to, {
      replace,
      state: { time: children?.props?.children },
      target,
    });

    return (
      <a
        ref={ref}
        {...rest}
        href={href}
        className="text-primary cursor-pointer"
        onClick={(event) => {
          onClick?.(event);
          if (!event.defaultPrevented) {
            handleClick(event);
          }
        }}
        target={target}
      >
        {children}
      </a>
    );
  },
);

export const htmlParser = (text: string, option?: HTMLReactParserOptions) => {
  return parser(text, {
    library: {
      createElement: (type, props, children) => {
        // @ts-ignore
        if (type === 'a' && props?.href?.startsWith('/time=')) {
          return <SeekLink {...props}>{children}</SeekLink>;
        }

        return React.createElement(
          type,
          {
            ...props,
            // @ts-ignore
            value: props.defaultValue,
            target: type === 'a' ? '_blank' : undefined,
            rel: type === 'a' ? 'noreferrer' : undefined,
          },
          children,
        );
      },
      cloneElement: (type, props, children) => {
        // @ts-ignore
        if (type === 'a' && props?.href?.startsWith('/time=')) {
          return <SeekLink {...props} text={children} />;
        }

        return React.cloneElement(
          type,
          // @ts-ignore
          { ...props, value: props.defaultValue },
          children,
        );
      },
      isValidElement: React.isValidElement,
    },
    ...option,
  });
};

export function escapeHtml(unsafe: string) {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
